import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class reportScheduleService {
  async fetch(params) {
    try {
      const result = await client.get('reportschedule/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`reportschedule/view/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async create(obj) {
    try {
      const result = await client.post('reportschedule/create', obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async update(id, obj) {
    try {
      const result = await client.post(`reportschedule/update/${id}`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`reportschedule/delete/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async run(id) {
    try {
      const result = await client.post(`reportschedule/run/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new reportScheduleService();
